<div class="main-container input" [ngClass]="{'disabled-input': isDisabled, 'invalid-input': invalidInput }">
  <div *ngIf="prefix" class="prefix d-flex justify-content-center align-items-center">
    <p class="mb-0 prefix-text">{{prefix | currencySymbol }}</p>
  </div>

  <input
    [value]="value"
    (input)="onInput($event)"
    (blur)="onBlur()"
    [readonly]="readonly"
    [placeholder]="placeHolder"
  />
</div>
